const { isNil } = require("lodash");

const sign_key     = "95D076FF587CAA7B";
const operator_id  = "0000017503";
const merchant_id  = "BC00004615";
const merCode      = "60bea7a2a91f61ac81c7616dc8d84c33";
const qrcode       = new QRCode("qr_code", {
  width: 148,
  height: 148,
});
let submission_id  = null;
let pay_processing = false;
let payment_info   = null;
let myCheckout = null;
let ticket = null;

window.clearInterval(window.payment_interval_id);
window.payment_interval_id = null;

function pad(number, length) {
  let str = "" + number;
  for(; str.length < length; ) str = '0' + str;
  return str;
}

function dateStrGenerate(data_obj) {
  const yyyy = data_obj.getFullYear().toString();
  const MM   = pad(data_obj.getMonth() + 1,2);
  const dd   = pad(data_obj.getDate(), 2);
  const hh   = pad(data_obj.getHours(), 2);
  const mm   = pad(data_obj.getMinutes(), 2)
  const ss   = pad(data_obj.getSeconds(), 2)

  return yyyy + MM + dd+  hh + mm + ss;
};

function ottpay_md5tool () {
	this.MSstring = "";
}

ottpay_md5tool.prototype = {

	getDataStrFromJson : function(jsonObject) {
    return jsonObject.toString();
	},

	getMD5StrFromJson : function(jsonObject) {
		const dataStr = this.sort(jsonObject);
		//console.log('sorted str='+dataStr);
    const md5Str = this.getMD5String(dataStr).toString().toUpperCase();

    return md5Str;
	},

	sort: function(jsonObject){

		//console.log('To sort jsonObject = '+jsonObject.toString());
		const obj = JSON.parse(jsonObject);
		//get sorted keylist
		const keylist = [];
		for(const key in obj){
			//console.log('to sort, key='+key);
			keylist.push(key);
		}
		keylist.sort();
		//console.log('to sort, keylist='+keylist);

		//get return str by retrieving value according to sorted key
		let return_str = "";
		for(let keyidx=0; keyidx < keylist.length; keyidx++ ){
      const value_idx = obj[keylist[keyidx]];
      if((typeof value_idx)=="number"){
          return_str += obj[keylist[keyidx]].toString()+".0";
      }else{
          return_str += obj[keylist[keyidx]];
      }

		}
        //console.log('after sort, return_str = '+return_str);

		return return_str;
	},

	getMD5String: function(dataStr) {
		return CryptoJS.MD5(dataStr);
    },

    decipher: function(orgData, key, md5) {

    	//console.log("To decrypt data = " + orgData);
    	//console.log("To decrypt md5 = " + md5);
    	//console.log("To decrypt key = " + key);
      const data = orgData.replace(/[\r\n' ']/g, '');
      //const data = orgData.replace(/[' ']/g, '');
      const aesKeyStr = CryptoJS.MD5(md5.concat(key)).toString().substring(8, 24).toUpperCase();
      //console.log("decrypt aes key = " + aesKeyStr);

      const dataArray = CryptoJS.enc.Base64.parse(data);
      const keyArray = CryptoJS.enc.Utf8.parse(aesKeyStr);

      const decrypted = CryptoJS.AES.decrypt({ciphertext: dataArray}, keyArray, {mode: CryptoJS.mode.ECB});
      //console.log("decrypted_Utf8",decrypted.toString(CryptoJS.enc.Utf8));
      //console.log("decrypted_u8array",this.hex2a(CryptoJS.enc.u8array.stringify(decrypted)));

      //const stb_u8array = this.sort(this.hex2a(CryptoJS.enc.u8array.stringify(decrypted)));
      //const calmd5 = this.getMD5String(stb_u8array).toString();
      //console.log("calculated u8array md5 = " + calmd5);

      const stb_utf8 = this.sort(decrypted.toString(CryptoJS.enc.Utf8));
      const calmd5 = this.getMD5String(stb_utf8).toString();
      //console.log("calculated utf8 md5 = " + calmd5);

      if (calmd5.toUpperCase()==md5.toUpperCase()) {
        return decrypted.toString(CryptoJS.enc.Utf8);
      } else {
        //alert("check sign fail");
        console.log("check sign fail");
        return JSON.stringify({error:"-1"});
      }

    },

    /**
     * Encryption
     *
     * @param data json
     * @param key
     * @param md5
     * @return
     */
    encrypted: function(data, key, md5) {

      const aesKeyStr = CryptoJS.MD5(md5.concat(key)).toString().substring(8, 24).toUpperCase();
      //console.log("in encrypted, aes key = " + aesKeyStr);

      const dataArray = CryptoJS.enc.Utf8.parse(data);
      const keyArray = CryptoJS.enc.Utf8.parse(aesKeyStr);

      const encrypt = CryptoJS.AES.encrypt(dataArray, keyArray, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});

      //console.log("encrypted, encrypt = " + encrypt.toString());

      return encrypt.toString();
    },

    hex2a: function(hex) {
      //const str = '';
      //for (const i = 0; i < hex.length; i++)
      //	str += String.fromCharCode(hex[i]);
          //str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    //return str;

      const encodedString = String.fromCharCode.apply(null, hex);
      return encodedString;

    },

    decipher_array: function(orgData, key, md5) {

    	//console.log("decrypt data = " + orgData);
    	//console.log("decrypt md5 = " + md5);
    	//console.log("decrypt key = " + key);
      const data = orgData.replace(/[\r\n' ']/g, '');
      const aesKeyStr = CryptoJS.MD5(md5.concat(key)).toString().substring(8, 24).toUpperCase();
      //console.log("decrypt aes key = " + aesKeyStr);

      const dataArray = CryptoJS.enc.Base64.parse(data);
      const keyArray = CryptoJS.enc.Utf8.parse(aesKeyStr);

      const decrypted = CryptoJS.AES.decrypt({ciphertext: dataArray}, keyArray, {mode: CryptoJS.mode.ECB});
      return decrypted.toString(CryptoJS.enc.Utf8);
    },

    sortarray: function(jsonObject){

		//console.log('jsonObject = '+jsonObject.toString());
		const obj = JSON.parse(jsonObject);
		//get sorted keylist
		const keylist = [];
		for(const key in obj){
			//console.log('to sort, key='+key);
			keylist.push(key);
		}
		keylist.sort();
		//console.log('to sort, keylist='+keylist);

		//get return str by retrieving value according to sorted key
		let return_str = "";
		for(let keyidx=0; keyidx<keylist.length; keyidx++ ){
			//console.log('after sort, key = '+keylist[keyidx]);
			//console.log('after sort, obj = '+JSON.stringify(obj[keylist[keyidx]]));
			if(obj[keylist[keyidx]]==""||obj[keylist[keyidx]]==null){
				return_str +="[]";
			}else{
				const tmp_str = JSON.stringify(obj[keylist[keyidx]]);
				return_str += tmp_str.replace(/":"/g, '=').replace(/","/g, ', ').replace(/"/g,'').replace(/},{/g,'}, {');
			}
		}
		//console.log('after sort, return_str = '+return_str);
		return return_str;
	},

}

function dataEncode(data) {
  if(data) {
    for(let key in data) {
      if(data[key] && (typeof data[key]) == "object") {
        dataEncode(data[key]);
      }

      if(data[key] && (typeof data[key]) == "string") {
        data[key] = data[key].replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }
    }
  }
}

function infoSave() {
  return new Promise((resolved, reject) => {
    const forms               = document.querySelectorAll("form");
    const csrf_token          = document.getElementById("csrf_token");
    const input_data          = { multiple_lines: [] };
    const http                = new XMLHttpRequest();
    const plan_supposed_price = document.querySelector("#plan_supposed_price");
    const token_type_input    = document.querySelector(`input[name="token_type"]`);
    const line_sections       = token_type_input.value == "HUP and AAL" ?
      [...document.querySelectorAll(`.existing_line_section`)].filter(item => item.style.display != "none") : 
      [...document.querySelectorAll(`.line_section`)];
    const yes_existing_user   = document.querySelector(`#yes_existing_customer`);


    input_data.existing_customer = yes_existing_user.checked ? 1 : 0;

    // submission_id = "1312312";
    // resolved();
    // return;

    forms.forEach(function(form) {
      if(!form.classList.contains("line_form")) {
        form = new FormData(form);

        form.forEach(function(value, key) {
          input_data[key] = value;
        });
      }
    });

    if(input_data["phone_model1"] != undefined || input_data["phone_model2"] != undefined) {
      input_data["phone_model"] = input_data["phone_model1"];
      delete input_data["phone_model1"];
      delete input_data["phone_model2"];
    }else input_data["phone_model"] = "";

    input_data["in_canada"]             = input_data["in_canada"] === undefined ? false : true;
    input_data["newphone_finance"]      = input_data["newphone_finance"] === undefined ? false : true;
    input_data["receive_email_from_pw"] = input_data["receive_email_from_pw"] === undefined ? false : true;

    if(input_data["primary_id_type"] === "Credit Card") {
      input_data["credit_card_expiry_month"] = input_data["primary_id_expiry_month"];
      input_data["credit_card_expiry_year"]  = input_data["primary_id_expiry_year"];
      input_data["credit_card_cvv"]          = "";
    }else if(input_data["secondary_id_type"] === "Credit Card") {
      input_data["credit_card_expiry_month"] = input_data["secondary_id_expiry_month"];
      input_data["credit_card_expiry_year"]  = input_data["secondary_id_expiry_year"];
      input_data["credit_card_cvv"]          = "";
    }

    if(plan_supposed_price) input_data["plan_price"] = plan_supposed_price.innerText;

    if(token_type_input.value == "HUP and AAL") {
      line_sections.forEach(line_section => {
        let form             = line_section.querySelector(`form`);
        const line_container = {};

        form = new FormData(form);

        form.forEach(function(value, key) {
          if(value && value != "null" && value != "undefined") {
            line_container[key] = value;
          }
        });

        line_container.customer_port_in_ctn = line_container.port_in_ctn;

        input_data.multiple_lines.push(line_container);
      });
    }else {
      line_sections.forEach(line_section => {
        if(line_section.style.display != "none") {
          let form             = line_section.querySelector(`form`);
          const plan_options   = [...line_section.querySelectorAll(`option`)];
          const line_container = {};

          form = new FormData(form);

          form.forEach(function(value, key) {
            if(value && value != "null" && value != "undefined") {
              line_container[key] = value;
            }
          });

          line_container.customer_port_in_ctn = line_container.port_in_ctn;

          plan_options.forEach(plan => {
            if(plan.selected) {
              line_container.plan_price   = plan.getAttribute("data-price") && plan.getAttribute("data-price") != "null" && plan.getAttribute("data-price") != "undefined" ? plan.getAttribute("data-price") : null;
              line_container.plan_type    = plan.getAttribute("data-type") && plan.getAttribute("data-type") != "null" && plan.getAttribute("data-type") != "undefined" ? plan.getAttribute("data-type") : null;
              line_container.plan_sku     = plan.getAttribute("data-sku") && plan.getAttribute("data-sku") != "null" && plan.getAttribute("data-sku") != "undefined" ? plan.getAttribute("data-sku") : null;
              line_container.soc_codes    = plan.getAttribute("data-soc") && plan.getAttribute("data-soc") != "null" && plan.getAttribute("data-soc") != "undefined" ? plan.getAttribute("data-soc") : null;
              line_container.aal_soc_code = plan.getAttribute("data-aal-soc") && plan.getAttribute("data-aal-soc") != "null" && plan.getAttribute("data-aal-soc") != "undefined" ? plan.getAttribute("data-aal-soc") : null;
            }
          });

          input_data.multiple_lines.push(line_container);
        }
      });
    }

    if(yes_existing_user.checked) {
      input_data.primary_credit_card_type = input_data.only_credit_card_type;
      input_data.primary_id               = input_data.only_id;
      input_data.primary_id_expiry_day    = input_data.only_id_expiry_day;
      input_data.primary_id_expiry_month  = input_data.only_id_expiry_month;
      input_data.primary_id_expiry_year   = input_data.only_id_expiry_year;
      input_data.primary_id_type          = input_data.only_id_type;
      input_data.email                    = input_data.existing_email;
      input_data.postal_code              = input_data.existing_postal_code;
    }

    if(input_data.day_of_birth && input_data.month_of_birth && input_data.year_of_birth) {
      input_data.date_of_birth = `${input_data.year_of_birth}-${input_data.month_of_birth}-${input_data.day_of_birth}`;
    }

    if(input_data.primary_id_expiry_day && input_data.primary_id_expiry_month && input_data.primary_id_expiry_year) {
      input_data.primary_id_expiry_date = `${input_data.primary_id_expiry_year}-${input_data.primary_id_expiry_month}-${input_data.primary_id_expiry_day}`;
    }

    if(input_data.secondary_id_expiry_day && input_data.secondary_id_expiry_month && input_data.secondary_id_expiry_year) {
      input_data.secondary_id_expiry_date = `${input_data.secondary_id_expiry_year}-${input_data.secondary_id_expiry_month}-${input_data.secondary_id_expiry_day}`;
    }

    if(input_data.guardian_id_expiry_day && input_data.guardian_id_expiry_month && input_data.guardian_id_expiry_year) {
      input_data.guardian_id_expiry_date = `${input_data.guardian_id_expiry_year}-${input_data.guardian_id_expiry_month}-${input_data.guardian_id_expiry_day}`;
    }

    dataEncode(input_data);

    http.open("POST", "/api/student-submission-complete", true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data = JSON.parse(http.responseText);

          if(reponse_data) {
            submission_id = reponse_data.id;
            resolved();
          }else {
            reject();
          }
        }else {
          reject();
        }
      }
    }

    http.send(JSON.stringify(input_data));
  });
}

function infoUpdate(data) {
  return new Promise((resolved, reject) => {
    const csrf_token = document.getElementById("csrf_token");
    const http       = new XMLHttpRequest();

    http.open("PATCH", "/api/student-submission", true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          resolved();
        }else {
          console.log("failed");
          reject();
        }
      }
    }

    http.send(JSON.stringify(data));
  });
}

function tokenStatusUpdate(data) {
  return new Promise((resolved, reject) => {
    const csrf_token = document.getElementById("csrf_token");
    const http       = new XMLHttpRequest();

    http.open("POST", "/api/invalidate-access-token", true);
    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          resolved();
        }else {
          console.log("failed");
          reject();
        }
      }
    }

    http.send(JSON.stringify(data));
  });
}

function paymentFeedbackHandle(paid_flag = true) {
  const submission_success = document.querySelector("#submission_success"); 
  const submission_form    = document.getElementById("submission_form");

  if(submission_id != null && paid_flag) infoUpdate({ id: submission_id, status: "pending", payment_info });

  paymentModalSwitch();

  if(submission_form) submission_form.style.display = "none";

  if(submission_success) submission_success.style.display = "block";

  // Swal.fire({
  //   title: "",
  //   text: document.getElementById("payment_success").textContent,
  //   icon: "success",
  //   confirmButtonText: "OK"
  // });
}

function orderTrack(order_id, pay_method = "") {
  window.clearInterval(window.payment_interval_id);

  const raw_data = {
    order_id
  };
  const http       = new XMLHttpRequest();
  const newtool    = new ottpay_md5tool();
  const md5_str    = newtool.getMD5StrFromJson(JSON.stringify(raw_data));
  const data_str   = newtool.getDataStrFromJson(JSON.stringify(raw_data));
  const key        = sign_key.toString().toUpperCase();
  const encrypted  = newtool.encrypted(data_str, key, md5_str);
  const input_data = {
    action: "STATUS_QUERY",
    version: "1.0",
    merchant_id: merchant_id,
    data: encrypted,
    md5: md5_str
  };

  window.payment_interval_id = window.setInterval(function () {
    http.open("POST", "https://frontapi.ottpay.com:443/processV3", true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data   = JSON.parse(http.responseText) || {};
          const decrypted_data = JSON.parse(newtool.decipher_array(reponse_data.data, key, reponse_data.md5));

          if(
            reponse_data.rsp_code === "SUCCESS" ||
            reponse_data.rsp_code === "ORDER_PAID" ||
            decrypted_data.order_status === "success"
          ) {
            payment_info = `OTT Pay (${pay_method}) - ` + decrypted_data.bizpay_order_id;
            paymentFeedbackHandle();
          }

        }else {
          console.log("failed");
        }
      }
    }

    http.send(JSON.stringify(input_data));
  }, 3000);
}

function qrCodeUpdate(code_url) {
  document.getElementById("code_msg").style.display        = "block";
  document.getElementById("code_container").style.display  = "block";
  document.getElementById("loading_spinner").style.display = "none";
  document.querySelector("#code_container > a").href       = code_url;
}

function paymentLinkGenerate(pay_method) {
  return new Promise((resolved, reject) => {
    const order_id_prefix = document.querySelector(`input[name="order_id_prefix"]`);
    const raw_data        = {
      amount: `${parseFloat(document.getElementById("total_price").value) * 100}`,
      biz_type: pay_method,
      operator_id: operator_id,
      order_id: `${order_id_prefix.value}${submission_id}`,
      call_back_url: window.location.href
    };
    const http            = new XMLHttpRequest();
    const newtool         = new ottpay_md5tool();
    const md5_str         = newtool.getMD5StrFromJson(JSON.stringify(raw_data));
    const data_str        = newtool.getDataStrFromJson(JSON.stringify(raw_data));
    const key             = sign_key.toString().toUpperCase();
    const encrypted       = newtool.encrypted(data_str, key, md5_str);
    const input_data      = {
      action: "ACTIVEPAY",
      version: "1.0",
      merchant_id: merchant_id,
      data: encrypted,
      md5: md5_str
    };

    http.open("POST", "https://frontapi.ottpay.com:443/processV3", true);

    //Send the proper header information along with the request
    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.onreadystatechange = function () {//Call a function when the state changes.
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data   = JSON.parse(http.responseText);
          const decrypted_data = JSON.parse(newtool.decipher_array(reponse_data.data, key, reponse_data.md5));

          if(reponse_data.rsp_code === "ORDER_USED") {
            Swal.fire({
              title: "",
              text: document.getElementById("used_order_id").textContent,
              icon: "error",
              confirmButtonText: document.getElementById("cancel_key").textContent
            });
            paymentModalSwitch(true);
            reject();
          }else {
            qrCodeUpdate(decrypted_data.code_url);
            qrcode.makeCode(decrypted_data.code_url);
            orderTrack(decrypted_data.order_id, pay_method);
            resolved();
          }
        }else {
          console.log("failed");
          reject();
        }
      }
    }

    http.send(JSON.stringify(input_data));
  });

}

function unionPaymentLinkGenerate() {
  return new Promise((resolved, reject) => {
    const raw_data = {
      merchant_id: merchant_id,
      txnTime: dateStrGenerate(new Date()),
      txnAmt: `${parseFloat(document.getElementById("total_price").value) * 100}`,
      frontUrl: window.location.href,
      backUrl: window.location.href,
      channelType: "UPAYONLINE",
      bizType: "securePay",
      cc_channelType: "web"
    };
    const http       = new XMLHttpRequest();
    const newtool    = new ottpay_md5tool();
    const md5_str    = newtool.getMD5StrFromJson(JSON.stringify(raw_data));
    const data_str   = newtool.getDataStrFromJson(JSON.stringify(raw_data));
    const key        = sign_key.toString().toUpperCase();
    const encrypted  = newtool.encrypted(data_str, key, md5_str);
    const input_data = {
      action: "CC_PURCHASE",
      version: "2.0",
      merchant_id: merchant_id,
      data: encrypted,
      md5: md5_str
    };

    http.open("POST", "https://frontapi.ottpay.com:443/processV3", true);

    //Send the proper header information along with the request
    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.onreadystatechange = function () {//Call a function when the state changes.
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data   = JSON.parse(http.responseText);
          const decrypted_data = JSON.parse(newtool.decipher_array(reponse_data.data, key, reponse_data.md5));

          const myWindow = window.open("", "_blank");
          myWindow.document.write(decrypted_data.codeUrl);

          orderTrack(unionPaymentOrderIdRetrieve(decrypted_data.codeUrl));
          console.log(decrypted_data);
          resolved();
        }else {
          console.log("failed");
          reject();
        }
      }
    }

    http.send(JSON.stringify(input_data));

  });
}

function unionPaymentOrderIdRetrieve(html_code) {
  const start = html_code.search(`id="orderId" value="`);
  const index = start + 20;
  let i       = index;

  for(; i < html_code.length && html_code[i] !== `"`; ++i);

  return html_code.substr(index, i - index);
}

function modalRestore() {
  const options = document.getElementsByClassName("method_button");
  const method  = document.getElementById("payment_method");

  window.clearInterval(window.payment_interval_id);
  pay_processing = false;

  document.getElementById("payment_method_body").style.display     = "block";
  document.getElementById("code_msg").style.display                = "none";
  document.getElementById("code_container").style.display          = "none";
  document.getElementById("loading_spinner").style.display         = "none";
  document.getElementById("modal_footer").style.display            = "none";
  document.getElementById("checkout_button").style.backgroundImage = "unset";
  document.querySelector(".modal_container").style.backgroundImage = "unset";
  method.value                                                     = "";

  for(let i = 0; i < options.length; ++i) options[i].classList.remove("active");
}

function paymentModalSwitch(close_flag = false) {
  const modal  = document.getElementById("payment_modal");
  const header = document.getElementById("stepper_header");

  if(close_flag || modal.style.display === "block") {
    modal.style.display   = "none";
    header.style.position = "sticky";
  }else {
    modal.style.display   = "block";
    header.style.position = "initial";
  }

  modalRestore();
}

function codeDisplay(wechat) {
  const modal      = document.querySelector(".modal_container");
  const buttons    = document.getElementById("payment_method_body");
  const footer     = document.getElementById("modal_footer");
  const footer_img = document.querySelector("#modal_footer > img");
  const loader     = document.getElementById("loading_spinner");

  buttons.style.display        = "none";
  footer.style.display         = "block";
  loader.style.display         = "block";
  footer.style.backgroundColor = "#ffffff";

  if(wechat) {
    modal.style.backgroundImage  = "linear-gradient(-225deg, #62cf64 0%, #30b02f 100%)";
    footer_img.src               = "/img/wechat_pay.png";
  }else {
    modal.style.backgroundImage  = "linear-gradient(-180deg,#3f8afe,#3568ff)";
    footer_img.src               = "/img/ali_pay.png";
  }
}

async function codeDetermine() {
  const method = document.getElementById("payment_method").value;
  const order_id_prefix = document.querySelector(`input[name="order_id_prefix"]`);

  if(method === "0") {
    if(isWechat()) {
      const amount   = `${parseFloat(document.getElementById("total_price").value) * 100}`;
      const lang     = document.getElementById("current_lang").innerText;
      const newURL   = `http://${window.location.hostname}/payment/wechat/${lang}`;
      const x_button = document.querySelector("#payment_modal .modal_close_btn");
      
      if(x_button) {
        x_button.style.display = "none";
      }

      window.location.href = `http://qrpay.ottpay.com/h5Pay?merCode=${merCode}&orderId=${order_id_prefix}${submission_id}&operId=${operator_id}&amount=${amount}&newURL=${newURL}`;
    }else {
      codeDisplay(true);
      paymentLinkGenerate("WECHATPAY");
    }
  }else if(method === "1") {
    codeDisplay(false);
    paymentLinkGenerate("ALIPAY");
  }else if(method === "2") {
    unionPaymentLinkGenerate();
  }else if(method === "3") {
    window.location.href = `/card-payment?id=${order_id_prefix}${submission_id}&amount=${parseFloat(document.getElementById("total_price").value)*100}&t=${document.querySelector(`input[name="access_token"]`).value}`;
  }else if(method === "4") {
    if (isNil(ticket)) {
      const data = await preloadTransaction();
      ticket = data?.data?.response?.ticket;
    }

    const form_container = document.querySelector(`#form_container`);
    const monerisCheckout = document.querySelector(`#monerisCheckout`);
    
    monerisCheckout.style.display = "block";
    form_container.style.display = "none";
    
    paymentModalSwitch(true);
    myCheckout.startCheckout(ticket);
  }else {  
    if(submission_id != null) {
      infoUpdate({ id: submission_id, status: "pending", payment_info: "Offline Payment" }).then(() => {
        window.location.href = `/?t=${document.querySelector(`input[name="access_token"]`).value}`;
      });
    }else {
      window.location.href = `/?t=${document.querySelector(`input[name="access_token"]`).value}`;
    }
  }
}

function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == "micromessenger";
}

function invalidatePortalAccessCode(data) {
  return new Promise((resolved, reject) => {
    const csrf_token = document.getElementById("csrf_token");
    const http       = new XMLHttpRequest();

    http.open("POST", "/api/invalidate-access-token", true);

    //Send the proper header information along with the request
    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {//Call a function when the state changes.
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data = JSON.parse(http.responseText);

          resolved();
        }else {
          console.log("failed");
          resolved();
        }
      }
    }

    http.send(JSON.stringify(data));
  });
}

function simImageSave() {
  return new Promise((resolved, reject) => {
    const csrf_token   = document.getElementById("csrf_token");
    const access_token = document.querySelector(`input[name="access_token"]`);
    const sim_images   = Array.from(document.querySelectorAll(`input[name="e_sim_image"]`));

    Promise.all(sim_images.map(async sim_image => {
      const input_data = new FormData();
      
      if(!sim_image.files[0]) {
        resolved();
        return;
      }
  
      input_data.append("line_id", sim_image.getAttribute("data-line-id"));
      input_data.append("access_token", access_token.value);
      input_data.append("e_sim_image", sim_image.files[0], sim_image.files[0].name);

      const res = await fetch(
        "/api/onboarding-sim-image-add",
        {
          method: "POST",
          headers: {
            "X-CSRF-Token": csrf_token.value
          },
          body: input_data
        }
      );

      return res.json();

    })).then(data => {
      resolved();
    });
  });
}

function idImageSave() {
  return new Promise((resolved, reject) => {
    const csrf_token   = document.getElementById("csrf_token");
    const access_token = document.querySelector(`input[name="access_token"]`);
    const id_image     = document.querySelector(`input[name="id_image"]`);
    const input_data   = new FormData();
    const http         = new XMLHttpRequest();

    if(!id_image.files[0]) {
      resolved();
      return;
    }

    input_data.append("token", access_token.value);

    input_data.append("photo", id_image.files[0], id_image.files[0].name);

    http.open("POST", "/api/id-photo", true);
    
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data = JSON.parse(http.responseText);

          if(reponse_data.success) {
            resolved();
          }else {
            reject();
          }
        }else {
          reject();
        }
      }
    };

    http.send(input_data);
  });
}

function id2ImageSave() {
  return new Promise((resolved, reject) => {
    const csrf_token   = document.getElementById("csrf_token");
    const access_token = document.querySelector(`input[name="access_token"]`);
    const id_image     = document.querySelector(`input[name="id_image_2"]`);
    const input_data   = new FormData();
    const http         = new XMLHttpRequest();

    if(!id_image.files[0]) {
      resolved();
      return;
    }

    input_data.append("token", access_token.value);

    input_data.append("photo", id_image.files[0], id_image.files[0].name);

    http.open("POST", "/api/id2-photo", true);
    
    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const reponse_data = JSON.parse(http.responseText);

          if(reponse_data.success) {
            resolved();
          }else {
            reject();
          }
        }else {
          reject();
        }
      }
    };

    http.send(input_data);
  });
}

async function preloadTransaction() {
  const csrf_token = document.getElementById("csrf_token");
  const total_price = document.getElementById("total_price").value;
  const access_token = document.querySelector(`input[name="access_token"]`).value;
  const order_id_prefix = document.querySelector(`input[name="order_id_prefix"]`);

  try {
      const response = await fetch("/api/moneris/preload", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrf_token.value
        },
        body: JSON.stringify({
          total_price,
          order_no: `${order_id_prefix}${access_token}`
        }),
      });

      if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      return response.json();

  } catch (error) {
      console.error("Error calling preloadTransaction API:", error);
  }
}

function monerisSetup() {
  const payment_env_type = document.querySelector(`input[name="payment_env_type"]`);

  myCheckout = new monerisCheckout();
  myCheckout.setMode(payment_env_type.value);
  myCheckout.setCheckoutDiv("monerisCheckout");

  myCheckout.setCallback("cancel_transaction", () => {
    const form_container = document.querySelector(`#form_container`);
    const monerisCheckout = document.querySelector(`#monerisCheckout`);
      
    form_container.style.display = "block";
    monerisCheckout.style.display = "none";
  });

  myCheckout.setCallback("payment_receipt", async () => {
    const access_token = document.querySelector(`input[name="access_token"]`);

    await infoUpdate({ id: submission_id, status: "pending", payment_info: `Moneris - A${access_token?.value ?? ""}` })

    window.location.href = `/?t=${access_token?.value}`;
  });
}

function makePromises() {
  const foreign_country = document.querySelector(`input[name="foreign_country"]`)?.value;

  const promises = foreign_country === "china"
    ? [simImageSave(), infoSave()]
    : [simImageSave(), idImageSave(), id2ImageSave(), infoSave()];
  
  return promises;
}

window.paymentMethodSelect = function(e) {
  const options = document.getElementsByClassName("method_button");
  const method  = document.getElementById("payment_method");
  const msg     = document.getElementById("code_msg");

  method.value    = e.dataset.index;
  msg.textContent = e.dataset.msg;

  document.getElementById("checkout_button").style.backgroundImage = "linear-gradient(-180deg,#3f8afe,#3568ff)";

  for(let i = 0; i < options.length; ++i) {
    if(options[i] === e) e.classList.add("active");
    else options[i].classList.remove("active");
  }

};

// document.getElementById("wechat_pay").addEventListener("click", function(event) {
//   event.preventDefault();
//   paymentLinkGenerate("WECHATPAY");
// });

// document.getElementById("ali_pay").addEventListener("click", function(event) {
//   event.preventDefault();
//   paymentLinkGenerate("ALIPAY");
// });

// document.getElementById("union_pay").addEventListener("click", function(event) {
//   event.preventDefault();
//   unionPaymentLinkGenerate();
// });

document.getElementById("payment_button").addEventListener("click", function(event) {
  const payment = document.querySelector(`input[name="payment"]`);

  if(payment.value == "0") {
    const promises = makePromises();

    Promise.all(promises)
      .then(async () => {
        window.location.href = `/?t=${document.querySelector(`input[name="access_token"]`).value}`;
      })
      .catch((err) => {
        Swal.fire({
          title: "",
          text: document.getElementById("cannot_save_submission").textContent,
          icon: "error",
          confirmButtonText: document.getElementById("cancel_key").textContent
        });

        paymentModalSwitch(true);
      });
    return;
  }

  paymentModalSwitch();
});

document.querySelector(`#payment_modal .modal_close_btn`).addEventListener("click", function(event) {
  paymentModalSwitch();
});

document.getElementById(`checkout_button`).addEventListener("click", function(event) {
  const method = document.getElementById("payment_method").value;
  
  if(method !== "" && !pay_processing) {
    pay_processing = true;
    const promises = makePromises();

    Promise.all(promises)
      .then(async () => {
        const access_token = document.querySelector(`input[name="access_token"]`);

        if(access_token) {
          await tokenStatusUpdate({
            token: access_token.value
          });
        }

        codeDetermine();
        setTimeout(() => paymentModalSwitch(true), 1000 * 60 * 20);
      })
      .catch((err) => {
        Swal.fire({
          title: "",
          text: document.getElementById("cannot_save_submission").textContent,
          icon: "error",
          confirmButtonText: document.getElementById("cancel_key").textContent
        });

        paymentModalSwitch(true);
      });
  }
});

window.addEventListener("load", () => {
  monerisSetup();
});